import {Card, FormControl, FormHelperText, FormLabel, Input, Radio, RadioGroup, Stack, Typography} from "@mui/joy";
import React, {useEffect} from "react";
import {useSettings} from "../../hooks/useSettings";
import {UserFormData} from "../../models/user";
import {LockIcon} from "lucide-react";
import {useUITheme} from "../../hooks/useUITheme";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

const ThemeSettingsSection = () => {
    const uiTheme = useUITheme()
    const navigate=useNavigate()
    const {t} = useTranslation()

    return <Stack gap={2}>
        <Card data-no-glow data-no-animation sx={{padding: 3}}>
            <Typography level={"title-md"}>
                {t("themeTitle")}
            </Typography>

            <RadioGroup value={uiTheme.theme} onChange={(event) => {
                uiTheme.setTheme(event.target.value as any)
                navigate(0)
            }}>
                <Radio value={"light"} label={t("lightThemeLabel")}/>
                <Radio value={"dark"} label={t("darkThemeLabel")}/>
                <Radio value={"glass"} label={t("gorillaThemeLabel")}/>
            </RadioGroup>

        </Card>
    </Stack>
}


export default ThemeSettingsSection